import styled from 'styled-components'

export const MilchmengeContainer = styled.div`
  height: 280px;
  width: 100%;
`
